import Cookies from 'js-cookie'

const state = {
  language: Cookies.get('motic_language') || 'zh-CN'
}

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('motic_language', language)
  }
}

const getters = {
    language: state => state.language,
  }
  
const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
